import u, { createContext as w, useCallback as k, useState as U, useMemo as d, useEffect as b, useContext as x } from "react";
import { GoogleReCaptchaProvider as C } from "react-google-recaptcha-v3";
import { u as p } from "./fallback-storage-value-DraZAU_d.mjs";
import { c as g } from "./environment-BQ4WWa7b.mjs";
import { c as N, g as A } from "./index-CnymUPx7.mjs";
const F = "signedUpNewsletters", E = "subscribed_newsletters", V = "signedUpNewslettersUpdateTime", H = 1e4;
let s = /* @__PURE__ */ function(t) {
  return t.Archive = "archive", t.Article = "article", t.Author = "author", t.Authors = "authors", t.Explained = "explained", t.Homepage = "homepage", t.Live = "live", t.Others = "others", t.Page = "page", t.Plus = "plus", t.Podcast = "podcast", t.Posties = "posties", t.PostiesArticle = "article_posties", t.PostiesEvent = "event_posties", t.PostiesEvents = "events_posties", t.PostiesKids = "content", t.PostiesParents = "brochure", t.PostiesSection = "section_posties", t.PostiesVideo = "video_posties", t.ScmpFilms = "scmp_films", t.Section = "section", t.Series = "series", t.Spotlight = "spotlight", t.StoryCard = "story-card", t.SubSection = "subsection", t.TalkingPost = "talking_post", t.Topic = "topic", t.TopicCollection = "topic_collection", t.Topics = "topics", t;
}({});
const $ = [s.Posties, s.PostiesArticle, s.PostiesEvent, s.PostiesEvents, s.PostiesKids, s.PostiesParents, s.PostiesSection, s.PostiesVideo];
let _ = /* @__PURE__ */ function(t) {
  return t.Article = "Article", t.Page = "Page", t.Section = "Section", t.Topic = "Topic", t;
}({});
const j = {
  article: {
    paywallTypeId: "716f570e-3083-4138-a080-47d3830fafe3"
  },
  topicType: {
    newsAgenda: "news_agenda"
  }
};
function G(t) {
  if (Object.values(_).includes(t))
    return t;
}
const v = /* @__PURE__ */ w(N("SdkContext")), K = ({
  children: t,
  value: e
}) => {
  const {
    remove: i,
    set: c,
    value: n
  } = p(E, {
    defaultValue: []
  }), {
    remove: a
  } = p(V, {
    defaultValue: 0
  }), S = k((o) => {
    c(o);
  }, [c]), [l, m] = U({
    acquisitions: {},
    campaigns: {},
    myNews: {},
    topicPackageFollows: {},
    whyRegister: {}
  }), h = d(() => ({
    popupState: l,
    setPopupState: m
  }), [l]);
  b(() => {
    e.user || (i(), a());
  }, [a, i, e.user]);
  const f = d(() => {
    try {
      var o;
      return new URL(e.currentRoute, (o = A()) === null || o === void 0 ? void 0 : o.location.origin).pathname;
    } catch {
      return "";
    }
  }, [e.currentRoute]);
  return /* @__PURE__ */ u.createElement(v.Provider, {
    value: {
      ...e,
      acquisition: h,
      currentRouteWithoutQuerystring: f,
      handleSetV1SignedUpNewslettersLocalStorage: S,
      v1SignedUpNewsletters: n ?? []
    },
    "data-qa": "sdk-context-provider"
  }, /* @__PURE__ */ u.createElement(C, {
    reCaptchaKey: e.config.recaptcha.siteKey
  }, t));
};
K.displayName = "SdkContextProvider";
const I = () => {
  const {
    config: t,
    environment: e,
    ...i
  } = x(v);
  return r("facebookLikeUrl", t == null ? void 0 : t.facebook.likeUrl), r("accountsHost", t == null ? void 0 : t.accounts.host), r("graphqlHost", t == null ? void 0 : t.graphql.host), r("subscribeHost", t == null ? void 0 : t.subscribe.host), {
    ...i,
    config: t,
    environment: e ?? g({
      authOptions: {
        allowEmptyToken: !0
      },
      urlOptions: {
        headers: {
          apikey: t.graphql.apiKey
        },
        method: "POST",
        url: t.graphql.host
      }
    })
  };
}, r = (t, e) => {
  if (e)
    try {
      new URL(e);
    } catch {
      console.error(`${t} is not a valid url format, value ${e}`);
    }
};
export {
  s as P,
  H as R,
  K as S,
  V as a,
  F as b,
  G as c,
  _ as d,
  $ as p,
  j as s,
  I as u
};
//# sourceMappingURL=contexts-BhsnKQH-.mjs.map
